import { render, staticRenderFns } from "./LeadProfile.vue?vue&type=template&id=887d5c72&scoped=true"
import script from "./LeadProfile.vue?vue&type=script&lang=js"
export * from "./LeadProfile.vue?vue&type=script&lang=js"
import style0 from "./LeadProfile.vue?vue&type=style&index=0&id=887d5c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887d5c72",
  null
  
)

export default component.exports